import * as t from 'io-ts';
import {mapValues} from 'lodash';

import {makeApiSerializableType} from './apiTypes';

/*
 * Runtime type.
 */

const RAccessDirty = t.readonly(
  t.type({
    namespaces: t.dictionary(t.string, t.union([t.undefined, t.string])),
    updatedAt: t.Integer,
  }),
);

/*
 * Type.
 */

export interface AccessModel extends t.TypeOf<typeof RAccessDirty> {}
export const RAccess = t.clean<AccessModel>(RAccessDirty as any);

/*
 * IO methods.
 */

export function parseAccess(src: any): AccessModel {
  const {access} = src;
  if (!access) {
    throw new Error('An access property could not be found.');
  }

  const namespaces = mapValues(access, (nsDef) => nsDef.role);

  return {namespaces, updatedAt: src.updated_at};
}

export function serializeAccess(access: AccessModel): any {
  return mapValues(access.namespaces, (roleAlias) => ({role: roleAlias}));
}

/*
 * API type.
 */

export const ApiAccess = makeApiSerializableType('access', RAccess, parseAccess, serializeAccess);
